import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface PostEngagementScore {
  postId: string;
  title: string | null;
  publishedAt: string | null;
  views: number;
  likes: number;
  comments: number;
  shares: number;
  bookmarks: number;
  reactions: number;
  downloads: number;
  revenue: number;
  score: number;
}

export interface TrendPoint {
  date: string;
  score: number;
  posts: number;
}

export interface EngagementSummary {
  overallScore: number;
  averagePerPost: number;
  totalInteractions: {
    views: number;
    likes: number;
    comments: number;
    shares: number;
    bookmarks: number;
    reactions: number;
    downloads: number;
    revenue: number;
  };
  topPosts: PostEngagementScore[];
  trend: TrendPoint[];
  breakdownPercentages: {
    views: number;
    likes: number;
    comments: number;
    shares: number;
    bookmarks: number;
    reactions: number;
    downloads: number;
  };
}

export interface HeatmapCell {
  day: number; // 0-6
  hour: number; // 0-23
  score: number;
}

export interface OptimalPostingSlot {
  day: number;
  hour: number;
  score: number;
  confidence: 'low' | 'medium' | 'high';
  rationale: string;
}

export interface OptimalPostingTimesResult {
  heatmap: HeatmapCell[];
  recommended: OptimalPostingSlot[];
  totalEvents: number;
  dataWindowDays: number;
  fallbackUsed: boolean;
}

export const engagementAnalyticsService = {
  async getSummary(startDate?: string, endDate?: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/analytics/engagement/summary`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { startDate, endDate },
    });
    return res.data as { success: boolean; data: EngagementSummary };
  },

  async getOptimalTimes(startDate?: string, endDate?: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/analytics/engagement/optimal-times`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { startDate, endDate },
    });
    return res.data as { success: boolean; data: OptimalPostingTimesResult };
  },
};
